export default __webpack_public_path__ + "static/media/_334.64d09c51.jpg";